import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CreateForm from '../../common/PCreatePost';
import MetaTags from 'react-meta-tags';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../../redux/actions';

import './createpost.scss';
import CloseButton from '../../common/CloseButton';
import { useHistory } from 'react-router';
import { ROLES } from '../../utils/constants';

const CreatePost = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const userInformation = JSON.parse(localStorage.getItem('user'));
    const handleSuccess = () => {
        dispatch(setAlert({
            show: true,
            body: `Post successfully added`
        }));
    };

    const handleGoToHomePage = () => {
        history.push(`/home`);
    };

    return (
        <div className="container pt-4 mb-4">
            <div className='create-post-header'>
                <span class="text-uppercase">New Post</span>
                <span><CloseButton onClick={handleGoToHomePage} /></span>
            </div>
            <MetaTags>
                <title>New Post &#8211; Best way to make money as an influencer for your exclusive content</title>
                <meta name="description" content="Privaposts is a social media platform that lets influencers make money from their followers by keeping exclusive content hidden until a monthly subscription price has been paid." />
            </MetaTags>

            {
                userInformation && [ROLES.PU, ROLES.ADMIN].includes(userInformation.role)
                    ? <CreateForm
                        schedule={false}
                        profile={false}
                        successHandler={handleSuccess}
                    />
                    : null
            }

            {
                userInformation && userInformation.role === ROLES.SU
                    ? <div className="create-become-creator-container text-center">
                        <h3>Earn money from your followers now!</h3>
                        <Link to="/become-creator" className="theme-btn theme-btn-bordered btn btn-primary">Become a Creator</Link>
                    </div>
                    : null
            }

        </div>
    );
};

export default CreatePost;
